import { render, staticRenderFns } from "./NewsCardContact.vue?vue&type=template&id=76d452a2&scoped=true&"
import script from "./NewsCardContact.vue?vue&type=script&lang=js&"
export * from "./NewsCardContact.vue?vue&type=script&lang=js&"
import style0 from "./NewsCardContact.vue?vue&type=style&index=0&id=76d452a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d452a2",
  null
  
)

export default component.exports